import React from 'react';

const Footer = () => {
    return (
        <footer className="bg-white border-t border-campus-border text-campus-text-body p-4 text-center mt-auto">
            <p className="text-sm">© 2024 vThink Global Technologies Pvt. Ltd. All Rights Reserved</p>
        </footer>
    );
};

export default Footer;
